
(function() {
  var result = { translations: { "af": { "i18n": { "duration": { "seconds": "{{ seconds }} sekondes", "minutes": "{{ minutes }} minute", "hours": "{{ hours }} uur", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dae", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u{{ minutes }}m" } }, "dateTime": { "quarterAndYear": "{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, uitbr. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "af": "static-7.1230"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1230",
    "ar-eg": "static-7.1230",
    "bg": "static-7.1230",
    "bn": "static-7.1230",
    "ca-es": "static-7.1230",
    "cs": "static-7.1230",
    "da": "static-7.1230",
    "de": "static-7.1230",
    "el": "static-7.1230",
    "en-gb": "static-7.1230",
    "en": "static-7.1230",
    "es-mx": "static-7.1230",
    "es": "static-7.1230",
    "et": "static-7.1230",
    "fi": "static-7.1230",
    "fr-ca": "static-7.1230",
    "fr": "static-7.1230",
    "he-il": "static-7.1230",
    "hi": "static-7.1230",
    "hr": "static-7.1230",
    "hu": "static-7.1230",
    "id": "static-7.1230",
    "it": "static-7.1230",
    "ja": "static-7.1230",
    "ko": "static-7.1230",
    "lt": "static-7.1230",
    "ms": "static-7.1230",
    "nl": "static-7.1230",
    "no": "static-7.1230",
    "pl": "static-7.1230",
    "pt-br": "static-7.1230",
    "pt-pt": "static-7.1230",
    "ro": "static-7.1230",
    "ru": "static-7.1230",
    "sk": "static-7.1230",
    "sl": "static-7.1230",
    "sv": "static-7.1230",
    "th": "static-7.1230",
    "tl": "static-7.1230",
    "tr": "static-7.1230",
    "uk": "static-7.1230",
    "vi": "static-7.1230",
    "x-pseudo": "static-7.1230",
    "zh-cn": "static-7.1230",
    "zh-hk": "static-7.1230",
    "zh-tw": "static-7.1230"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:af', {version: 'static-7.1230'}); }
})();


